import { FC } from 'react';
import { createUseStyles } from 'react-jss';
import { IAgencyDigest } from '@innerhive-internal/innerhive-common';
import { CHART_INK } from './agencyChartTheme';
import { formatUpdatedAt } from './insightsDates';

const useStyles = createUseStyles({
    updated: {
        marginLeft: 'auto',
        fontSize: 12.5,
        color: CHART_INK.label,

        // The printed sheet's band already says when and over what window.
        '@media print': {
            display: 'none'
        }
    },

    count: {
        fontVariantNumeric: 'tabular-nums'
    }
});

/**
 * How many of the caseload's clients the figures include, when they were updated, and the window
 * they cover. The clients left out are the ones the panel above the reports names.
 */
export const CaseloadUpdated: FC<{ digest: IAgencyDigest }> = ({ digest }) => {
    const classes = useStyles();
    const total = digest.clientCount + digest.unreadableCount;

    return (
        <span className={classes.updated} data-id="insights-window">
            <span className={classes.count} data-id="insights-client-count">{digest.clientCount}</span>
            {` of ${total} ${total === 1 ? 'Client' : 'Clients'} Included · Updated ${formatUpdatedAt({ iso: digest.readAt, now: new Date() })} · last ${digest.windowWeeks} weeks`}
        </span>
    );
};
